import * as React from "react"
import { Row, Col, Button, Alert } from "reactstrap"
// import FacebookLogin from "react-facebook-login"
import GoogleLogin from "react-google-login"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import AppConfig from "../../configs/AppConfig"
import { FormattedMessage, intlShape } from "react-intl"
import { ValidationForm, TextInput } from "react-bootstrap4-form-validation"
import { connect } from "react-redux"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"
import { IExternalSignin } from "../../redux/sagaAuth/ISagaAuth"
import validator from "validator"
import "./signin.css"

class Signin extends React.Component<
  {
    requestLogin?: (email, password) => void
    requestExternalLogin: (data: IExternalSignin) => void
    loginSuccess?: () => void
    onResetPassword: () => void
  },
  {
    loginFetching: boolean
    loginResponse: any
    loginError: string
    email: string
    password: string
  }
> {
  /* tslint:disable */
  private static contextTypes = {
    intl: intlShape
  }

  constructor(props, context) {
    super(props)
    this.state = {
      loginFetching: false,
      loginResponse: null,
      loginError: null,
      email: null,
      password: null
    }
    this.context = context
  }

  public componentWillReceiveProps(newProps) {
    const newState: any = {}
    newState.loginFetching = newProps.loginFetching
    newState.loginResponse = newProps.loginResponse
    newState.loginError = newProps.loginError
    if (newProps.loginResponse) {
      this.props.loginSuccess()
    }
    this.setState(newState)
  }

  public responseFacebook(response) {
    console.log("response from facebook login", response)
    if (response.accessToken && response.email && response.id) {
      // invoke external signin api
      const data: IExternalSignin = {
        accessToken: response.accessToken,
        email: response.email,
        familyName: response.name,
        givenName: response.name,
        provider: "facebook",
        mobilePhone: "",
        imageUrl: "",
        providerId: response.userID
      }
      this.props.requestExternalLogin(data)
    } else {
      alert("Social logins require cookies enabled. Please exit incognito mode")
    }
  }

  public responseGoogle(response) {
    console.log("*** response from google login", response)
    if (response.accessToken && response.googleId && response.profileObj) {
      // invoke external signin api
      const data: IExternalSignin = {
        accessToken: response.accessToken,
        email: response.profileObj.email,
        familyName: response.profileObj.familyName,
        givenName: response.profileObj.givenName,
        provider: "google",
        mobilePhone: "",
        imageUrl: response.profileObj.imageUrl,
        providerId: response.googleId
      }
      this.props.requestExternalLogin(data)
    } else {
      alert("Social logins require cookies enabled. Please exit incognito mode")
    }
  }

  public onResetPassword() {}

  public onSubmit(e) {
    e.preventDefault()
    // invoke singin api
    this.props.requestLogin(this.state.email, this.state.password)
  }

  public render() {
    return (
      <ValidationForm className="mt-3" onSubmit={e => this.onSubmit(e)}>
        <div className="mb-3 form-group">
          <TextInput
            name="signin-email"
            id="signin-email"
            type="email"
            validator={validator.isEmail}
            placeholder={this.context.intl.formatMessage({ id: "Email" })}
            onChange={e => this.setState({ email: e.target.value })}
            errorMessage={{
              required: (
                <FormattedMessage id="Signin.Validation.Email.Required" />
              ),
              validator: (
                <FormattedMessage id="Signin.Validation.Email.Invalid" />
              )
            }}
            required
          />
        </div>
        <div className="mb-3 form-group">
          <TextInput
            type="password"
            name="signin-password"
            id="signin-password"
            onChange={e => this.setState({ password: e.target.value })}
            errorMessage={{
              required: (
                <FormattedMessage id="Signin.Validation.Password.Required" />
              )
            }}
            placeholder={this.context.intl.formatMessage({ id: "Password" })}
            required
          />
        </div>
        <Row className="mb-3">
          <Col>
            <Button
              color="danger"
              size="md"
              disabled={this.state.loginFetching}
            >
              <FormattedMessage id="Submit" />
            </Button>
          </Col>
          <Col className="text-right">
            <span
              className="anchor-span"
              onClick={() => this.props.onResetPassword()}
            >
              <FormattedMessage id="ForgotPassword" />
            </span>
          </Col>
        </Row>
        {this.state.loginError ? (
          <Row className="mb-3">
            <Col>
              <Alert color="danger">{this.state.loginError}</Alert>
            </Col>
          </Row>
        ) : null}
        <Row className="mb-3">
          <Col>
            <div className="dashed">
              <span>
                <FormattedMessage id="Or" />
              </span>
            </div>
          </Col>
        </Row>
        <Row className="mb-3">
          <Col lg={12} className="mb-3">
            <GoogleLogin
              clientId={AppConfig.google.clientId}
              onSuccess={response => this.responseGoogle(response)}
              onFailure={response => this.responseGoogle(response)}
              render={renderProps => (
                <Button
                  className="google-btn"
                  onClick={renderProps.onClick}
                  block
                >
                  <FontAwesomeIcon icon={["fab", "google"]} />
                  &nbsp;
                  <FormattedMessage id="SigninWithGoogle" />
                </Button>
              )}
            />
          </Col>
          <Col lg={12}>
            <FacebookLogin
              appId={AppConfig.facebook.appId}
              autoLoad={false}
              fields="name,email,picture"
              callback={response => this.responseFacebook(response)}
              render={renderProps => (
                <Button
                  onClick={renderProps.onClick}
                  className="facebook-btn"
                  block
                >
                  <FontAwesomeIcon icon={["fab", "facebook-f"]} />
                  &nbsp;
                  <FormattedMessage id="SigninWithFacebook" />
                </Button>
              )}
            />
          </Col>
        </Row>
      </ValidationForm>
    )
  }
}

const mapStateToProps = state => {
  return {
    loginFetching: state.SagaAuth.loginFetching,
    loginResponse: state.SagaAuth.loginResponse,
    loginError: state.SagaAuth.loginError
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestLogin: (email, password) =>
      dispatch(SagaAuthRedux.requestLogin(email, password)),
    requestExternalLogin: (data: IExternalSignin) =>
      dispatch(SagaAuthRedux.requestExternalLogin(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signin)



// WEBPACK FOOTER //
// ./src/components/accountModal/signin.tsx